import Chart from '@/components/chart-settings'

import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'OrdersChart',
  props: {
    dataChart: {
      type: Array,
      default: () => [0, 0, 0, 0]
    }
  },
  static() {
    const ticksStyle = {
      font: {
        size: 14,
        lineHeight: '16px',
        family: "'Circe', sans-serif"
      },
      color: 'rgba(0, 0, 0, .4)'
    }
    return {
      chartObject: null,
      chartOptions: {
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 20,
            left: -10
          }
        },
        plugins: {
          legend: {
            display: false
          }
        },
        /**
         * Важно, иначе будет баг с наведением.
         * Чарт будет перерировываться.
         * Чарт должен перерисовываться ТОЛЬКО при получении или обновлении данных
         */
        events: [],
        scales: {
          x: {
            grid: {
              drawBorder: false,
              display: false
            },
            ticks: {
              font: ticksStyle.font,
              color: function(context) {
                if (context.index === 0) {
                  return 'rgb(0, 0, 0)'
                }
                return ticksStyle.color
              }
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              color: 'rgba(128, 128, 128, .32)',
            },
            ticks: {
              ...ticksStyle,
              padding: 12,
              callback(value) {
                if (value < 1000) {
                  return value
                }
                let thousandValue = value / 1000
                if ( value % 1000 !== 0) {
                  thousandValue = thousandValue.toFixed(1)
                }
                return `${numberWithSeparator(thousandValue)}k`
              }
            }
          }
        },
        animation: {
          onComplete({ chart }) {
            const ctx = chart.ctx
            ctx.textAlign = 'center'
            
            ctx.textBaseline = 'bottom'
            chart.data.datasets.forEach(function (dataset, i) {
              const meta = chart.getDatasetMeta(i)
              meta.data.forEach(function (bar, index) {
                if (index === 0) {
                  ctx.fillStyle = '#000000'
                } else {
                  ctx.fillStyle = '#808080'
                }
                const data = dataset.data[index]
                ctx.fillText(numberWithSeparator(data), bar.x, bar.y - 5)
              })
            })
          }
        }
      }
    }
  },
  mounted() {
    this.renderUpdateChart()
  },
  methods: {
    getFullData() {
      return {
        labels: ['Сегодня', '-7 дн.', '-14 дн', '-7 дн. всего'],
        datasets: [{
          data: this.dataChart,
          backgroundColor: [
            '#593289',
            '#F1EFF3',
            '#F1EFF3',
            '#F1EFF3'
          ],
          borderRadius: 6,
          borderSkipped: false,
          categoryPercentage: 1,
          barPercentage: 0.9
        }]
      }
    },
    renderUpdateChart() {
      if (!this.chartObject) {
        this.chartObject = new Chart(
          this.$refs.canvas,
          {
            type: 'bar',
            data: this.getFullData(),
            options: this.chartOptions
          }
        )
      } else {
        this.chartObject.data.datasets[0].data = this.dataChart
        this.chartObject.update()
      }
    }
  },
  watch: {
    dataChart() {
      this.renderUpdateChart()
    }
  }
}